export default __webpack_public_path__ + "static/media/ic_check.99bb4fec.svg";